export default function changePasswordForm() {
    this.popup('changePassword', {});
    return true;
}
